import { jsx as _jsx } from "react/jsx-runtime";
import UIIcon from 'UIComponents/icon/UIIcon';
const icons = {
  linkedin: {
    name: 'socialBlockLinkedin',
    color: '#0E76A8'
  },
  twitter: {
    name: 'socialBlockTwitter',
    color: '#00acee'
  },
  github: {
    name: 'github',
    color: '#000000',
    transform: 'scale(85%) translateY(-15%)'
  },
  meetings: {
    name: 'meetings',
    color: '#FF7A59',
    transform: 'translateY(-3.5%)'
  }
};

const SocialIcon = ({
  className,
  socialMediaName,
  size = 28
}) => /*#__PURE__*/_jsx(UIIcon, {
  className: className,
  name: icons[socialMediaName].name,
  color: icons[socialMediaName].color,
  size: size,
  style: {
    transform: icons[socialMediaName].transform
  }
});

export default SocialIcon;